import axios from "axios";
import {
  createFormHeaders,
  createFormHeadersAdmin,
  createHeadersAdmin,
} from "../../utils/Utils"
import { BASE_URL } from "../../assets/constants/constants";

//! Banner
//  Banner Add
export const addHomeBannerAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}upload-document`, data, headers);
};
//  Banner List
export const getHomeBannerListAPI = async (data) => {
  const headers = createHeadersAdmin();

  return await axios.post(`${BASE_URL()}get-document`, data, headers);
};

// Banner Edit api
export const getBannerEditAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}edit-document`, data, headers);
};

// Banner Status UpdateAPI
export const statusUpdateBannerAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}edit-document-status`, data, headers);
};

//! VIPBanner
//  VIPBanner Add
export const addHomeVIPBannerAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}upload--vip-document`, data, headers);
};
//  VIPBanner List
export const getHomeVIPBannerListAPI = async (data) => {
  const headers = createHeadersAdmin();

  return await axios.post(`${BASE_URL()}get-vip-document`, data, headers);
};

// VIPBanner Edit api
export const getVIPBannerEditAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}edit-vip-document`, data, headers);
};

// VIPBanner Status UpdateAPI
export const statusUpdateVIPBannerAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}edit-vip-document-status`, data, headers);
};

//ADD Management directory API
export const addMngmntDirAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}add-mange-directory`, data, headers);
};

//GET Management directory API
export const getManageDirAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-mange-directory-data`, data, headers);
};

//UPDATE Management directory API
export const editManageDirAPI = async (data) => {
  const headers = createFormHeaders();
  return await axios.post(`${BASE_URL()}update-mange-directory`, data, headers);
};

//ADD ORG srtucture API
export const addOrgStrAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}add-organizational`, data, headers);
};

//GET ORG srtucture API
export const getOrgStructureAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-organizational`, data, headers);
};

//UPDATE ORG srtucture API
export const editOrgStructureAPI = async (data) => {
  const headers = createHeadersAdmin();

  return await axios.post(`${BASE_URL()}update-organizational`, data, headers);
};

//ADD NEWS  API
export const addNewsAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}add-news`, data, headers);
};

//GET NEWS API
export const getNewsAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-news`, data, headers);
};

//UPDATE NEWS API
export const editNewsAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-news`, data, headers);
};

//ADD Events and announcements  API
export const addEventAndAnnounceAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}add-news`, data, headers);
};

//GET Events and announcements API
export const getEventAndAnnounceAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-news`, data, headers);
};

//UPDATE Events and announcements API
export const editEventAndAnnounceAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-news`, data, headers);
};

//  Gallery List
export const getPhotoGalleryListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-gallery-photos`, data, headers);
};

//GET Events and announcements List API
export const getInfoAboutListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-infoAbout`, data, headers);
};

//ADD Events and announcements  API
export const addInfoAboutAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}add-infoAbout`, data, headers);
};

//UPDATE Events and announcements API
export const getInfoAboutEditAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-infoAbout`, data, headers);
};
